import { Alert, Snackbar } from '@mui/material'
import { ReactNode, useState, useCallback } from 'react'

export interface ToastMessage {
  type: 'success' | 'error' | 'warning' | 'info'
  message: ReactNode
}

export function useToast() {
  const [toast, setToast] = useState<ToastMessage | null>(null)

  const showToast = useCallback((type: ToastMessage['type'], message: ReactNode) => {
    setToast({ type, message })
  }, [])

  const hideToast = useCallback(() => {
    setToast(null)
  }, [])

  const showSuccess = useCallback((message: ReactNode) => {
    showToast('success', message)
  }, [showToast])

  const showError = useCallback((message: ReactNode) => {
    showToast('error', message)
  }, [showToast])

  const ToastComponent = () => {
    if (!toast) return null

    return (
      <Snackbar
        open={!!toast}
        autoHideDuration={4000}
        onClose={hideToast}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert severity={toast.type} onClose={hideToast} variant="filled">
          {toast.message}
        </Alert>
      </Snackbar>
    )
  }

  return {
    showToast,
    showSuccess,
    showError,
    hideToast,
    ToastComponent,
  }
}